import API from "../axios";

const getTelegramList = async (accessToken, userId) => {
    try {
        const response = await API.get(`/telegram/list?user_id=${userId}`, {
            headers: {
                Authorization: `Bearer ${accessToken.replace('Bearer ', '')}`
            }
        });
        return response.data;
    } catch (error) {
        if (error.response) {
            return error.response.data;
        }
        return {
            success: false,
            message: 'Lỗi kết nối mạng'
        }
    }
}

export default getTelegramList; 
